import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/stores/auth.store'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'landing',
    component: () => import('@/pages/LandingPage.vue'),
    meta: { public: true },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/LoginPage.vue'),
    meta: { layout: 'auth', public: true },
  },
  {
    path: '/app',
    component: () => import('@/layouts/DefaultLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      { path: '', redirect: { name: 'listings' } },
      {
        path: 'filters',
        name: 'filters',
        component: () => import('@/pages/FiltersPage.vue'),
      },
      {
        path: 'filters/:id',
        name: 'filter-detail',
        component: () => import('@/pages/FilterDetailPage.vue'),
      },
      {
        path: 'listings',
        name: 'listings',
        component: () => import('@/pages/ListingsPage.vue'),
      },
      {
        path: 'listings/:id',
        name: 'listing-detail',
        component: () => import('@/pages/ListingDetailPage.vue'),
      },
      {
        path: 'settings',
        name: 'settings',
        component: () => import('@/pages/SettingsPage.vue'),
      },
      {
        path: 'admin',
        meta: { requiresAdmin: true },
        children: [
          { path: '', redirect: { name: 'admin-stats' } },
          {
            path: 'stats',
            name: 'admin-stats',
            component: () => import('@/pages/admin/AdminStatsPage.vue'),
          },
          {
            path: 'users',
            name: 'admin-users',
            component: () => import('@/pages/admin/AdminUsersPage.vue'),
          },
          {
            path: 'users/:id',
            name: 'admin-user-detail',
            component: () => import('@/pages/admin/AdminUserDetailPage.vue'),
          },
          {
            path: 'filters',
            name: 'admin-filters',
            component: () => import('@/pages/admin/AdminFiltersPage.vue'),
          },
          {
            path: 'queues',
            name: 'admin-queues',
            component: () => import('@/pages/admin/AdminQueuesPage.vue'),
          },
        ],
      },
    ],
  },
  { path: '/:pathMatch(.*)*', redirect: '/' },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()

  if (to.meta['public']) return true

  if (!auth.isAuthenticated) {
    return { name: 'login', query: { next: to.fullPath } }
  }

  if (!auth.user) {
    try {
      await auth.fetchMe()
    } catch {
      auth.logout()
      return { name: 'login' }
    }
  }

  if (to.matched.some((r) => r.meta['requiresAdmin']) && !auth.isAdmin) {
    return { name: 'listings' }
  }

  return true
})
